import React, { memo } from 'react';
import { Grid } from "@mui/material";
import DownloadCSVButton from "../../report/export/DownloadCSVButton";
import {
  getSupplierSpaceUsageReportUrl
} from "../../../requests/reports/space-usage/supplier-space-usage-requests";
import DownloadSpaceUsageCSVButton from '../DownloadSpaceUsageCSVButton';

/**
 * Component for exporting supplier space usage data as CSV files
 *
 * @param {Object} props
 * @param {Object} props.query - Query parameters for the report
 * @param {string} props.query.startDate - Start date for the report
 * @param {string} props.query.endDate - End date for the report
 * @param {string} props.query.locationId - Location ID filter
 * @param {string} props.query.bookingNumber - Booking number filter
 * @param {string} props.query.overageInvoiceNumber - Overage invoice number filter
 * @param {string} props.query.sortBy - Sort field
 * @param {string} props.query.sortDir - Sort direction
 * @param {Function} props.snackbarShowMessage - Function to show snackbar notifications
 * @returns {JSX.Element}
 */
const SpaceUsageExportCSVs = (props) => {
  const { query } = props;

  const spaceUtilizationReportUrl = getSupplierSpaceUsageReportUrl(query);

  return (
    <Grid item container lg xs={12} gap={2} justifyContent={'end'} wrap={'nowrap'}>
      <Grid item>
        <DownloadCSVButton
          reportUrl={spaceUtilizationReportUrl}
          title={'Download Report'}
        />
      </Grid>
      <DownloadSpaceUsageCSVButton
        isBuyer={false}
        query={query}
      />
    </Grid>
  )
}

export default memo(SpaceUsageExportCSVs);